import { getReq } from '../service/API'
import useSWR from 'swr'
import { ENDPOINTS } from '../service/ENDPOINTS'

export const useCras = (projectId: string) => {
  //const p = PORTAL_API_URL + '/me/cras/' + projectId
  const p = ENDPOINTS.CRA.byProjectId(projectId)
  const { data, error, mutate } = useSWR(p, getReq, { suspense: true })

  return {
    data: !data ? data : data.data,
    isLoading: !error && !data,
    isError: error,
    mutate: mutate,
  }
}
